import * as yup from 'yup';

import { validatePassword } from 'src/utils/validators/validate-password';

import { setPasswordDataKeys } from './constants';

const errorMessages = {
    password: {
        required: 'your_details_form_password_required',
        min: 'your_details_form_password_min',
        invalid: 'your_details_form_password_invalid',
    },
    confirmPassword: {
        doesNotMatch: 'your_details_form_repeat_password_invalid',
    },
};

export const setPasswordDataSchema = yup.object({
    [setPasswordDataKeys.password]: yup
        .string()
        .required(errorMessages.password.required)
        .min(8, errorMessages.password.min)
        .test({ message: errorMessages.password.invalid, test: validatePassword }),
    [setPasswordDataKeys.confirmPassword]: yup
        .string()
        .oneOf([yup.ref('password')], errorMessages.confirmPassword.doesNotMatch),
});
